import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { getRouterLinkUrlById } from '@lsq-frontend/common-ui';
import { atlas, ENROLLMENT } from '@lsq-frontend/fasttrack-shared/routing-atlas';

@Component({
    selector: 'registration-redirect',
    template: `<lsq-circle-loader></lsq-circle-loader>`
})
export class RegistrationRedirectComponent implements OnInit {
    constructor(private _router: Router) {}

    public async ngOnInit(): Promise<void> {
        await this._router.navigateByUrl(
            getRouterLinkUrlById(atlas, ENROLLMENT) + '?' + (this._router.url.split('?')[1] || '')
        );
    }
}
